<template>
  <div class='animated fadeIn'>
  <div v-if='myService.length > 1'>
    <b-form-select v-model="myServiceSelected" :options="myService" class="mb-3" />
  </div>
    <b-tabs class='mb-5'>
      <b-tab v-if='user && user.role != "user"' title='ランキング' :active='tab == 0' @click='tabSelected(0)'>
        <b-card v-if='isRanking' border-variant='white' class='p-0' no-body>
          <b-row>
            <b-col sm='5'>
              <h4 id='traffic' class='card-title mb-0'>ランキング</h4>
              <div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div>
            </b-col>
            <b-col>
               <p variant="light" class='small ml-auto text-info' style='text-align:right;'>※ 提出率ランキング = グループメンバーの提出数合計 /（グループメンバー人数 * 7日）</p>
            </b-col>
          </b-row>
          <div v-for='rank in ranking' :key='rank.key'>
            <b-card-body class='py-2'>
              <b-row class='d-flex justify-content-center'>
                <div>
                  <b-img v-if='rank.rank == 1' src='../static/images/rank1.png' style='max-width:40px; height:40px;'></b-img>
                  <b-img v-if='rank.rank == 2' src='../static/images/rank2.png' style='max-width:40px; height:40px;'></b-img>
                  <b-img v-if='rank.rank == 3' src='../static/images/rank3.png' style='max-width:40px; height:40px;'></b-img>
                </div>
                <div class='progress-group' style='width:84%;'>
                  <b-col sm='12'>
                    <div class='progress-group-header'>
                      <div class='avatar'>
                      <b-img :src='rank.icon' style='max-width:40px; height:auto;'></b-img>
                      </div>
                      <span class='title pl-2' style='font-size:20px;' >{{ rank.name }}</span>
                      <span class='ml-auto font-weight-bold'>{{ rank.ratio }}%</span>
                    </div>
                    <div class='progress-group-bars'>
                      <b-progress height='10px' class='progress-xs' :value='rank.ratio' variant='danger'></b-progress>
                    </div>
                  </b-col>
                </div>
              </b-row>
            </b-card-body>
          </div>
        </b-card>
      </b-tab>
      <b-tab v-else title='個人' :active='tab == 0' @click='tabSelected(0)'>
        <b-card v-if="user && user.role == 'user'" border-variant='white' class='p-0' no-body="">
          <b-row>
            <b-col sm='8' class='mb-1'>
              <h4 id='traffic' class='card-title mb-0'>達成度</h4>
              <div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div>
            </b-col>
            <b-col sm='4'>
              <div class='mr-auto'>開始:{{ routineStart }}- 提出:{{ totalSubmit }}回 経過日数:{{ totalDate }}日</div>
            </b-col>
          </b-row>
          <b-row class='d-flex justify-content-center mb-2'>
            <b-button-toolbar key-nav  aria-label='Toolbar with button groups'>
              <b-button-group class='mx-1'>
                <b-btn v-if="selected != 'Month'" variant='outline-primary' v-on:click='rew()'>&laquo;</b-btn>
                <b-btn variant='outline-primary' v-on:click='left()'>&lsaquo;</b-btn>
              </b-button-group>
              <b-button-group class='mx-1'>
                <b-btn variant='outline-primary' v-on:click='today()'>本日</b-btn>
              </b-button-group>
              <b-button-group class='mx-1'>
                <b-btn variant='outline-primary' v-on:click='right()'>&rsaquo;</b-btn>
                <b-btn v-if="selected != 'Month'" variant='outline-primary' v-on:click='ff()'>&raquo;</b-btn>
              </b-button-group>
            </b-button-toolbar>
            <b-button-toolbar key-nav aria-label='Toolbar with button groups'>
              <b-form-radio-group class='mr-3' id='radiosBtn' buttons button-variant='outline-primary' v-model='selected' name='radiosBtn'>
                <b-form-radio class='select-btn' value='Month' button-variant='outline-danger'>月</b-form-radio>
                <b-form-radio class='select-btn' value='Week' button-variant='outline-success'>週</b-form-radio>
                <b-form-radio class='select-btn' value='Day'  button-variant='outline-primary'>日</b-form-radio>
              </b-form-radio-group>
            </b-button-toolbar>
          </b-row>
          <b-row class='d-flex justify-content-center'>
            <b-col sm='12' lg='10' class='px-2'>
              <b-card :class='bgColor' class='p-0 m-0'>
                <bar-chart class='chart-wrapper p-0 m-0' :chartData='chartData' :options='options' height='240'/>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="user && user.role == 'user' && isRoutine" border-variant='white' class='p-0' no-body>
          <b-row>
            <b-col sm='5'>
              <h4 id='traffic' class='card-title mb-0'>ルーティン</h4>
              <div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div>
            </b-col>
          </b-row>

          <b-row>
            <b-col class='p-0'>
              <b-card-body>
                <b-row class='d-flex justify-content-center'>
                  <b-col sm='12'>
                  <div class='table-responsive'>
                    <b-table
                      responsive
                      :items='statusTable'
                      :fields='fields'
                      >
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='title' slot-scope='item'>
                        <p v-if='item.item.type == "self"' class='p-0 m-0'>{{ item.value }}</p>
                        <p v-else class='p-0 m-0'>【共通】{{ item.value }}</p>
                      </div>
                      <div slot='category' slot-scope='item'>
                        <p class='p-0 m-0'>[{{categoryText(item.value)}}]</p>
                      </div>
                      <div slot='day0' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='day1' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='day2' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='day3' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='day4' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='day5' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='day6' slot-scope='item'>
                        <p v-if='item.value == 0' class='p-0 m-0'>/</p><p v-else-if='item.value == 1' class='p-0 m-0'>X</p><p v-else-if='item.value == 2' class='p-0 m-0'>○</p>
                      </div>
                      <div slot='total' slot-scope='item'>
                        <p class='p-0 m-0'>{{ item.value }}%</p>
                      </div>
                    </b-table>
                  </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>

      <b-tab title='グループ' :active='tab == 1' @click='tabSelected(1)'>
        <b-card v-if='isRanking && user && user.role == "user"' border-variant='white' class='p-0' no-body>
          <b-row>
            <b-col sm='5'>
              <h4 id='traffic' class='card-title mb-0'>ランキング</h4>
              <div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div>
            </b-col>
            <b-col>
               <p variant="light" class='small ml-auto text-info' style='text-align:right;'>※ 提出率ランキング = グループメンバーの提出数合計 /（グループメンバー人数 * 7日）</p>
            </b-col>
          </b-row>

          <div v-for='rank in ranking' :key='rank.key'>
            <b-card-body class='py-2'>
              <b-row class='d-flex justify-content-center'>
                <div>
                  <b-img v-if='rank.rank == 1' src='../static/images/rank1.png' style='max-width:40px; height:40px;'></b-img>
                  <b-img v-if='rank.rank == 2' src='../static/images/rank2.png' style='max-width:40px; height:40px;'></b-img>
                  <b-img v-if='rank.rank == 3' src='../static/images/rank3.png' style='max-width:40px; height:40px;'></b-img>
                </div>
                <div class='progress-group' style='width:84%;'>
                  <b-col sm='12'>
                    <div class='progress-group-header'>
                      <div class='avatar'>
                      <b-img :src='rank.icon' style='max-width:40px; height:auto;'></b-img>
                      </div>
                      <span class='title pl-2' style='font-size:20px;' >{{ rank.name }}</span>
                      <span class='ml-auto font-weight-bold'>{{ rank.ratio }}%</span>
                    </div>
                    <div class='progress-group-bars'>
                      <b-progress height='10px' class='progress-xs' :value='rank.ratio' variant='danger'></b-progress>
                    </div>
                  </b-col>
                </div>
              </b-row>
            </b-card-body>
          </div>
        </b-card>
        <div v-for='(value, index) in members' :key='index'>
          <b-card border-variant='white' no-body class='p-0 m-1'>
            <b-row>
              <b-col sm='5'>
                <div class='d-flex'>
                <div class='avatar'>
                  <b-img v-if='value.group.icon' :src='value.group.icon' width='40' height='40'></b-img>
                </div>
                <div><h4 class='card-title mb-0 pl-2'>{{value.group.name }}</h4><div class='small text-muted'>{{ rankStart }} - {{ rankEnd }}</div></div>
                </div>
              </b-col>
            </b-row>
            <b-card-body class='p-0 m-0'>
              <b-row>
                <b-col class='pl-4 pr-4 m-0'>
                  <div class='table-responsive'>
                    <b-table
                      :items='value.users'
                      :fields='groupFields'
                      >
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                      </div>
                      <!-- <div slot='number' slot-scope='item'>
                        {{ membersRoutineNumber[item.item.key] }}
                      </div>
                      <div slot='submit' slot-scope='item'>
                        {{ getSubmitNumber(item.item) }}/7(日)
                      </div> -->
                      <template slot='key' slot-scope='row'>
                        <b-button size='sm' @click.stop='row.toggleDetails' variant='primary'>
                          詳細 {{ row.detailsShowing ? '非表示' : '表示' }}
                        </b-button>
                      </template>
                      <template slot='row-details' slot-scope='row'>
                         <achivement :user='row.item' :offset='offset'></achivement>
                      </template>
                    </b-table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </div>
      </b-tab>
      <b-tab v-if='user && user.role != "user"' title='個人' :active='tab == 2' @click='tabSelected(2)'>
        <b-card-body class='p-0 m-0'>
          <b-row>
            <b-col class='pl-2 pr-2 m-0'>
              <div class='table-responsive'>
                <b-table
                  :items='myUsers'
                  :fields='groupFieldsManagement'
                  >
                  <div slot='icon' class='avatar' slot-scope='item'>
                    <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                    <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                    <i v-else class='fas fa-user-circle fa-3x'></i>
                  </div>
                  <div slot='routineNumber' slot-scope='item'>
                    {{ item.value }}
                  </div>
                  <div slot='submitNumber' slot-scope='item'>
                    {{ item.value }}/7(日)
                    <div v-if='item.value < 3'><i class="fas fa-chart-line my-gray"></i></div>
                    <div v-else-if='item.value < 5'><i class="fas fa-chart-line my-orange"></i></div>
                    <div v-else><i class="fas fa-chart-line my-blue"></i></div>
                  </div>
                  <div slot='ratio' slot-scope='item'>
                     {{ item.value }}
                    <div v-if='item.value < 30'><i class="fas fa-trophy my-gray"></i></div>
                    <div v-else-if='item.value < 60'><i class="fas fa-trophy my-orange"></i></div>
                    <div v-else><i class="fas fa-trophy my-blue"></i></div>
                  </div>
                  <div slot='status' slot-scope='item' class="p-1">
                    {{ item.value }}
                  </div>
                  <template slot='key' slot-scope='row'>
                    <b-button size='sm' @click.stop='row.toggleDetails' variant='primary'>
                      詳細 {{ row.detailsShowing ? '非表示' : '表示' }}
                    </b-button>
                    <!-- <b-button size='sm' @click.stop='printAchieve(row.item)' variant='secondary'><i class="el-icon-printer"></i></b-button> -->
                  </template>
                  <template slot='row-details' slot-scope='row'>
                      <achivement :user='row.item' :offset='offset'></achivement>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
        <!-- <modal class='table-responsive p-0 m-0' :adaptive='true' width="80%" :height='840' style='z-index:10000;' name="print-achieve" @before-open="beforeOpen">
          <div id="printThis">
          <b-card border-variant='white'>
            <b-row class="pl-4">
              <div class='avatar' style="width:60px;height:60px;">
                <b-img v-if='printUser' :src='printUser.icon'></b-img>
              </div>
              <div><h4 v-if='printUser' class='card-title mb-0 pl-2'>{{ printUser.name }}</h4><div v-if='printUser' class='small text-muted'>{{ printUser.status }}</div></div>
              <b-col sm="5"></b-col>
              <div class="ml-auto pr-4 py-1 align-middle">
                <el-button id="print-button" size="small" type="success" icon="el-icon-printer" @click='modalPrint()'></el-button>
              </div>
            </b-row>
          </b-card>
            <achivement id="achivement" :user='printUser'></achivement>
          </div>
        </modal> -->
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BarChart from '@/components/BarChart'
import Achivement from '@/components/Achivement'
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default {
  name: 'dashboard',
  components: {
    BarChart,
    Achivement
  },
  data () {
    return {
      tab: 0,
      selfFields: {
        title: {
          label: 'ルーティン',
          class: 'text-left',
          sortable: true
        },
        category: {
          label: 'カテゴリー',
          class: 'text-center',
          sortable: true
        }
      },
      sCurrentPage: 1,
      sPerPage: 10,
      groupFields: {
        icon: {
          label: '',
          class: 'text-center p-1'
        },
        name: {
          label: '名前',
          class: 'text-center small p-0',
          sortable: true
        },
        status: {
          label: '私のスローガン',
          class: 'text-center small p-0',
          sortable: false
        },
        // number: {
        //   label: 'ルーティン数',
        //   class: 'text-center small p-0',
        //   sortable: true
        // },
        // submit: {
        //   label: '提出率',
        //   class: 'text-center small p-0',
        //   sortable: true
        // },
        ratio: {
          label: '達成度(%)',
          class: 'text-center small p-0',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center p-0 m-0'
        }
      },
      groupFieldsManagement: {
        icon: {
          label: '',
          class: 'text-left p-1'
        },
        name: {
          label: '名前',
          class: 'text-center small p-0',
          sortable: true
        },
        routineNumber: {
          label: 'ルーティン数',
          class: 'text-center small p-0',
          sortable: true
        },
        submitNumber: {
          label: '提出率',
          class: 'text-center small p-0',
          sortable: true
        },
        ratio: {
          label: '達成度(%)',
          class: 'text-center small p-0',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center small p-0'
        },
        status: {
          label: '私のスローガン',
          class: 'text-center small status',
          sortable: false
        }
      },
      gCurrentPage: 1,
      gPerPage: 10,
      active: ['1'],
      items: {},
      fields: {
        title: {
          label: 'ルーティン',
          class: 'text-left small p-0',
          sortable: true
        },
        category: {
          label: 'カテゴリー',
          class: 'text-center small p-0',
          sortable: true
        },
        day0: {
          label: '',
          class: 'th-date small p-0'
        },
        day1: {
          label: '',
          class: 'th-date small p-0'
        },
        day2: {
          label: '',
          class: 'th-date small p-0'
        },
        day3: {
          label: '',
          class: 'th-date small p-0'
        },
        day4: {
          label: '',
          class: 'th-date small p-0'
        },
        day5: {
          label: '',
          class: 'th-date small p-0'
        },
        day6: {
          label: '',
          class: 'th-date small p-0'
        },
        total: {
          label: '達成度',
          class: 'text-center small p-0',
          sortable: true
        }
      },
      currentPage: 1,
      perPage: 10,
      chartData: {},
      options: {},
      selected: 'Day',
      isSelected: false,
      bgColor: 'bg-primary',
      routine: null,
      offset: 0,
      week: Array(52),
      month: Array(13),
      load: null,
      isRanking: true,
      isRoutine: true,
      unwatch0: null,
      unwatch1: null,
      unwatch2: null,
      unwatch3: null,
      ranking: [],
      rankStart: null,
      rankEnd: null,
      statusTable: [],
      members: [],
      membersData: {},
      membersRoutine: {},
      membersRoutineNumber: {},
      usersData: {},
      myService: [],
      myServiceSelected: null,
      myUsers: [],
      isCalculateData: false,
      isCalcRanking: false,
      isGetMembers: false,
      routineStart: null,
      totalSubmit: 0,
      totalDate: 0,
      printUser: null
    }
  },
  beforeDestroy () {
    if (this.unwatch0) {
      this.unwatch0()
      this.unwatch0 = null
    }
    if (this.unwatch1) {
      this.unwatch1()
      this.unwatch1 = null
    }
    if (this.unwatch2) {
      this.unwatch2()
      this.unwatch2 = null
    }
    if (this.unwatch3) {
      this.unwatch3()
      this.unwatch3 = null
    }
  },
  watch: {
    selected: function () {
      if (!this.isSelected) {
        this.offset = 0
      }
      // this.fillData()
      if (this.selected === 'Day') {
        this.bgColor = 'bg-primary'
        // this.isRanking = true
        this.isRoutine = true
        this.calcRanking()
      } else if (this.selected === 'Week') {
        this.bgColor = 'bg-success'
        // this.isRanking = false
        this.isRoutine = false
      } else {
        this.bgColor = 'bg-danger'
        // this.isRanking = false
        this.isRoutine = false
      }
      this.isSelected = false
      this.calculateData()
    },
    myServiceSelected: function () {
      this.calculateData()
    }
  },
  created () {
    this.unwatch3 = this.$store.watch(
      state => this.$store.getters['service/services'],
      value => {
        this.createServiceSelector()
      }
    )
    if (this.services) {
      this.createServiceSelector()
    }

    if (!this.init || !this.data) {
      this.$store.dispatch('dispatch/setLoading', true)
    } else {
      this.calculateData()
    }
    if (!this.init) {
      this.unwatch0 = this.$store.watch(
        state => this.$store.getters['authUser/init'],
        value => {
          if (value) {
            this.getUserData()
          }
        }
      )
    } else if (!this.data) {
      this.getUserData()
    }

    this.unwatch1 = this.$store.watch(
      state => this.$store.getters['dispatch/data'],
      value => {
        if (this.init && this.data && value) {
          this.$store.dispatch('dispatch/setLoading', false)
        }
      }
    )

    this.unwatch2 = this.$store.watch(
      state => this.$store.getters['routineData/routineData'],
      value => {
        if (value) {
          this.calculateData()
        }
      }
    )
  },
  methods: {
    isDateValid (item) {
      var status = false
      const range = moment.range(item.startAt, item.endAt)
      for (var i = 0; i < 7; i++) {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offset + i)
        var str = moment(objDate).format('YYYY/MM/DD')
        var state = { date: str }
        var today = parseInt(moment(Date.parse(state.date)).format('X'))
        if (range.contains(today)) {
          status = true
          break
        }
      }
      return status
    },
    setRoutines (temp, id) {
      var objDate = new Date()
      objDate.setDate(objDate.getDate() - 6 + this.offset)
      var str = moment(objDate).format('YYYY/MM/DD')
      for (var x in temp) {
        const payload = {
          type: id,
          key: temp[x].key,
          date: str,
          day0: 0,
          day1: 0,
          day2: 0,
          day3: 0,
          day4: 0,
          day5: 0,
          day6: 0,
          total: 100,
          title: temp[x].title,
          category: temp[x].category
        }
        this.statusTable.push(payload)
      }
    },
    createMyRoutine () {
      this.statusTable = []
      var user = null
      var index = this.users.findIndex(u => u.key === firebase.auth().currentUser.uid)
      if (index !== -1) {
        user = JSON.parse(JSON.stringify(this.users[index]))
      } else {
        return
      }
      var temp = []
      var keys = Object.keys(user.services)
      for (var i in keys) {
        if (user.services[keys[i]]) {
          index = this.services.findIndex(service => service.key === keys[i])
          if (index !== -1) {
            for (var x in this.services[index].routine) {
              var rIndex = this.routineRefs.findIndex(r => r.key === this.services[index].routine[x])
              if (rIndex !== -1 && this.isDateValid(this.routineRefs[rIndex])) {
                var gIndex = this.routineGroups.findIndex(rg => rg.key === this.routineRefs[rIndex].routine_ref)
                if (gIndex !== -1) {
                  for (var y in this.routineGroups[gIndex].routines) {
                    var r = this.routines.findIndex(r => r.key === this.routineGroups[gIndex].routines[y])
                    if (r !== -1) {
                      temp.push(JSON.parse(JSON.stringify(this.routines[r])))
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.setRoutines(temp, 'service')
      temp = []
      keys = Object.keys(user.groups)
      for (i in keys) {
        if (user.groups[keys[i]]) {
          index = this.groups.findIndex(group => group.key === keys[i])
          if (index !== -1) {
            for (x in this.groups[index].routine) {
              rIndex = this.routineRefs.findIndex(r => r.key === this.groups[index].routine[x])
              if (rIndex !== -1 && this.isDateValid(this.routineRefs[rIndex])) {
                gIndex = this.routineGroups.findIndex(rg => rg.key === this.routineRefs[rIndex].routine_ref)
                if (gIndex !== -1) {
                  for (y in this.routineGroups[gIndex].routines) {
                    r = this.routines.findIndex(r => r.key === this.routineGroups[gIndex].routines[y])
                    if (r !== -1) {
                      temp.push(JSON.parse(JSON.stringify(this.routines[r])))
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.setRoutines(temp, 'group')
      temp = []
      for (x in user.routine) {
        rIndex = this.routineRefs.findIndex(r => r.key === user.routine[x])
        if (rIndex !== -1 && this.isDateValid(this.routineRefs[rIndex])) {
          gIndex = this.routineGroups.findIndex(rg => rg.key === this.routineRefs[rIndex].routine_ref)
          if (gIndex !== -1) {
            for (y in this.routineGroups[gIndex].routines) {
              r = this.routines.findIndex(r => r.key === this.routineGroups[gIndex].routines[y])
              if (r !== -1) {
                temp.push(JSON.parse(JSON.stringify(this.routines[r])))
              }
            }
          }
        }
      }
      this.setRoutines(temp, 'user')
      temp = []
      for (x in this.routineSelf) {
        temp.push(this.routineSelf[x])
      }
      this.setRoutines(temp, 'self')
    },
    modalPrint () {
      var elem = document.getElementById('printThis')
      var domClone = elem.cloneNode(true)
      var $printSection = document.getElementById('printSection')
      if (!$printSection) {
        $printSection = document.createElement('div')
        $printSection.id = 'printSection'
        document.body.appendChild($printSection)
      }
      $printSection.innerHTML = ''
      $printSection.appendChild(domClone)
      this.$nextTick(function () {
        setTimeout(() => {
          try {
            document.execCommand('print', false, null)
          } catch (e) {
            window.print()
          }
        }, 500)
      })
    },
    printAchieve (item) {
      this.$modal.show('print-achieve', { data: item })
    },
    beforeOpen (event) {
      this.printUser = null
      this.printUser = event.params.data
    },
    close () {
      this.$modal.hide('print-achieve')
    },
    createServiceSelector () {
      this.myServiceSelected = null
      this.myService = []
      if (this.user) {
        for (var key in this.user.services) {
          if (this.user.services[key]) {
            var index = this.services.findIndex(service => service.key === key)
            if (index !== -1) {
              var service = JSON.parse(JSON.stringify(this.services[index]))
              this.myService.push({
                value: service.key,
                text: service.name
              })
            }
          }
        }
      }
      if (this.myService.length !== 0) {
        this.myServiceSelected = this.myService[0].value
      }
    },
    tabSelected (index) {
      this.tab = index
      // this.$store.dispatch('dispatch/setTab', this.tab)
    },
    getUserData () {
      this.$store.dispatch('routineData/init')
      this.$store.dispatch('routineData/subscribe').then(() => {
        this.calculateData()
        this.$store.dispatch('dispatch/setData', true)
      })
    },
    calculateData () {
      if (this.isCalculateData) {
        return
      }
      this.isCalculateData = true
      this.calcStatics()
      this.fillData()
      this.calcRanking()
      this.calcStatusTable()
      this.calcSubmitCount()
      this.isCalculateData = false
    },
    openLoading () {
      this.load = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        if (this.load) {
          this.load.close()
          this.load = null
        }
      }, 5000)
    },
    calcSubmitCount () {
      var temp = null
      for (var ref in this.routineRefs) {
        var start = new Date(this.routineRefs[ref].startAt * 1000)
        if (temp) {
          if (temp > start) {
            temp = start
          }
        } else {
          temp = start
        }
        this.routineStart = moment(start).format('YYYY/MM/DD')
        this.totalDate = Math.floor((((new Date() - start) / 1000) / 86400))
        this.totalSubmit = this.routineData.length
      }
    },
    calcStatics () {
      // var w = 51
      // var m = 12
      this.week.fill(0)
      this.month.fill(0)
      for (var i = 0; i < 364; i++) {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - (363 - i))
        var str = moment(objDate).format('YYYY/MM/DD')
        const index = this.routineData.findIndex(
          routine => routine.dateText === str
        )
        if (index !== -1) {
          var routine = this.routineData[index]
          this.week[Math.floor(i / 7)] += routine.routineCounter.total.done
          this.month[Math.floor(i / 28)] += routine.routineCounter.total.done
        }
      }
    },
    calcStatusTable () {
      // this.statusTable = []
      this.createMyRoutine()
      for (var i = 0; i < 7; i++) {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offset + i)
        var str = moment(objDate).format('YYYY/MM/DD')
        var label = 'day' + String(i)
        this.fields[label].label = moment(objDate).format('DD')
        var index = this.routineData.findIndex(
          routine => routine.dateText === str
        )
        if (index !== -1) {
          var data = this.routineData[index]
          for (var key in data.routineService) {
            for (var r in data.routineService[key]) {
              index = this.routines.findIndex(routine => routine.key === r)
              if (index !== -1) {
                var routine = this.routines[index]
                var offset = this.statusTable.findIndex(
                  status => status.key === r
                )
                if (offset === -1) {
                  const payload = {
                    type: 'service',
                    key: r,
                    date: str,
                    day0: null,
                    day1: null,
                    day2: null,
                    day3: null,
                    day4: null,
                    day5: null,
                    day6: null,
                    total: null,
                    title: routine.title,
                    category: routine.category
                  }
                  payload[label] = data.routineService[key][r]
                  if (payload[label] === 2 || payload[label] === 0) {
                    payload.total = 100
                  } else {
                    payload.total = 0
                  }
                  this.statusTable.push(payload)
                } else {
                  var status = this.statusTable[offset]
                  status[label] = data.routineService[key][r]
                  var number = 0
                  var done = 0
                  for (var x = 0; x < 7; x++) {
                    var d = 'day' + String(x)
                    if (this.statusTable[offset][d] !== null) {
                      number += 1
                      if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                        done += 1
                      }
                    }
                  }
                  this.statusTable[offset].total = Math.floor(
                    100 * (done / number)
                  )
                }
              }
            }
          }
          for (key in data.routineGroup) {
            for (r in data.routineGroup[key]) {
              index = this.routines.findIndex(routine => routine.key === r)
              if (index !== -1) {
                routine = this.routines[index]
                offset = this.statusTable.findIndex(
                  status => status.key === r
                )
                if (offset === -1) {
                  const payload = {
                    type: 'group',
                    key: r,
                    date: str,
                    day0: null,
                    day1: null,
                    day2: null,
                    day3: null,
                    day4: null,
                    day5: null,
                    day6: null,
                    total: null,
                    title: routine.title,
                    category: routine.category,
                    data: data.routineGroup[key][r]
                  }
                  payload[label] = data.routineGroup[key][r]
                  if (payload[label] === 2 || payload[label] === 0) {
                    payload.total = 100
                  } else {
                    payload.total = 0
                  }
                  this.statusTable.push(payload)
                } else {
                  status = this.statusTable[offset]
                  status[label] = data.routineGroup[key][r]
                  number = 0
                  done = 0
                  for (x = 0; x < 7; x++) {
                    d = 'day' + String(x)
                    if (this.statusTable[offset][d] !== null) {
                      number += 1
                      if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                        done += 1
                      }
                    }
                  }
                  this.statusTable[offset].total = Math.floor(
                    100 * (done / number)
                  )
                }
              }
            }
          }
          for (r in data.routineUser) {
            index = this.routines.findIndex(routine => routine.key === r)
            if (index !== -1) {
              routine = this.routines[index]
              offset = this.statusTable.findIndex(
                status => status.key === r
              )
              if (offset === -1) {
                const payload = {
                  type: 'user',
                  key: r,
                  date: str,
                  day0: null,
                  day1: null,
                  day2: null,
                  day3: null,
                  day4: null,
                  day5: null,
                  day6: null,
                  total: null,
                  title: routine.title,
                  category: routine.category,
                  data: data.routineUser[r]
                }
                payload[label] = data.routineUser[r]
                if (payload[label] === 2 || payload[label] === 0) {
                  payload.total = 100
                } else {
                  payload.total = 0
                }
                this.statusTable.push(payload)
              } else {
                status = this.statusTable[offset]
                status[label] = data.routineUser[r]
                number = 0
                done = 0
                for (x = 0; x < 7; x++) {
                  d = 'day' + String(x)
                  if (this.statusTable[offset][d] !== null) {
                    number += 1
                    if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                      done += 1
                    }
                  }
                }
                this.statusTable[offset].total = Math.floor(
                  100 * (done / number)
                )
              }
            }
          }
          for (r in data.routineSelf) {
            index = this.routineSelf.findIndex(routine => routine.key === r)
            if (index !== -1) {
              routine = this.routineSelf[index]
              offset = this.statusTable.findIndex(
                status => status.key === r
              )
              if (offset === -1) {
                const payload = {
                  type: 'self',
                  key: r,
                  date: str,
                  day0: null,
                  day1: null,
                  day2: null,
                  day3: null,
                  day4: null,
                  day5: null,
                  day6: null,
                  total: null,
                  title: routine.title,
                  category: routine.category,
                  data: data.routineUser[r]
                }
                payload[label] = data.routineSelf[r]
                if (payload[label] === 2 || payload[label] === 0) {
                  payload.total = 100
                } else {
                  payload.total = 0
                }
                this.statusTable.push(payload)
              } else {
                status = this.statusTable[offset]
                status[label] = data.routineSelf[r]
                number = 0
                done = 0
                for (x = 0; x < 7; x++) {
                  d = 'day' + String(x)
                  if (this.statusTable[offset][d] !== null) {
                    number += 1
                    if (this.statusTable[offset][d] === 2 || this.statusTable[offset][d] === 0) {
                      done += 1
                    }
                  }
                }
                this.statusTable[offset].total = Math.floor(
                  100 * (done / number)
                )
              }
            }
          }
        }
      }
    },
    rew () {
      var value = this.offset - 7
      if (this.selected === 'Week') {
        if (value < -45) {
          value = -45
        }
      } else {
        if (value < -358) {
          value = -358
        }
      }
      this.offset = value
      this.fillData()
      this.calcRanking()
      this.calcStatusTable()
    },
    ff () {
      var value = this.offset + 7
      if (value > 0) {
        value = 0
      }
      this.offset = value
      this.fillData()
      this.calcRanking()
      this.calcStatusTable()
    },
    left () {
      if (this.selected === 'Month') {
        if (this.offset === -6) {
          return
        }
      }
      if (this.selected === 'Week') {
        if (this.offset === -45) {
          return
        }
      }
      if (this.selected === 'Day') {
        if (this.offset === -358) {
          return
        }
      }
      this.offset -= 1
      this.fillData()
      this.calcRanking()
      this.calcStatusTable()
      // }
    },
    today () {
      this.offset = 0
      this.fillData()
      this.calcRanking()
      this.calcStatusTable()
    },
    right () {
      if (this.offset !== 0) {
        this.offset += 1
        this.fillData()
        this.calcRanking()
        this.calcStatusTable()
      }
    },
    fillData () {
      var vm = this
      const data = {
        labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        datasets: [
          {
            label: 'Achivement',
            backgroundColor: 'rgba(255,255,255,.3)',
            borderColor: 'white',
            borderWidth: 1,
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      }

      const option = {
        tooltips: {
          enabled: false
          // custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true,
              // categoryPercentage: 1,
              // barPercentage: 0.5
              gridLines: {
                display: false
              },
              ticks: {
                fontColor: '#fff',
                fontSize: 10
              }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontColor: '#fff',
                fontSize: 10,
                beginAtZero: true,
                min: 0,
                max: 40
              }
            }
          ]
        },
        onClick: function (e, el) {
          if (!el || el.length === 0) return
          if (vm.selected === 'Month') {
            vm.offset = (vm.offset - (6 - el[0]._index)) * 4
            vm.isSelected = true
            vm.selected = 'Week'
          } else if (vm.selected === 'Week') {
            vm.offset = (vm.offset - (6 - el[0]._index)) * 7
            vm.isSelected = true
            vm.selected = 'Day'
          }
        }
      }
      var tempOption = option
      if (this.selected === 'Day') {
        tempOption.scales.yAxes[0].ticks.max = 32
      } else if (this.selected === 'Week') {
        tempOption.scales.yAxes[0].ticks.max = 32 * 7
      } else {
        tempOption.scales.yAxes[0].ticks.max = 32 * 28
      }
      this.options = {}
      this.options = tempOption
      var chartTemp = data
      var counter = 7
      if (this.selected === 'Month') {
        counter = 7
      }
      chartTemp.labels = Array(counter)
      chartTemp.datasets[0].data = Array(counter)
      chartTemp.labels.fill('')
      chartTemp.datasets[0].data.fill(0)
      if (this.selected === 'Day') {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offset)
        this.rankStart = moment(objDate).format('YYYY/MM/DD')
        objDate = new Date()
        objDate.setDate(objDate.getDate() + this.offset)
        this.rankEnd = moment(objDate).format('YYYY/MM/DD')

        for (var i = 0; i < counter; i++) {
          objDate = new Date()
          objDate.setDate(objDate.getDate() - 6 + this.offset + i)
          var str = moment(objDate).format('YYYY/MM/DD')
          const index = this.routineData.findIndex(
            routine => routine.dateText === str
          )
          if (index !== -1) {
            var routine = this.routineData[index]
            chartTemp.datasets[0].data[i] = routine.routineCounter.total.done
          }
          chartTemp.labels[i] = moment(objDate).format('MM/DD')
        }
      } else if (this.selected === 'Week') {
        objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 * 7 + this.offset * 7)
        this.rankStart = moment(objDate).format('YYYY/MM/DD')
        objDate = new Date()
        objDate.setDate(objDate.getDate() + this.offset * 7)
        this.rankEnd = moment(objDate).format('YYYY/MM/DD')

        for (i = 0; i < counter; i++) {
          objDate = new Date()
          objDate.setDate(objDate.getDate() - 6 * 7 + this.offset * 7 + i * 7)
          str = moment(objDate).format('YYYY/MM/DD')
          chartTemp.datasets[0].data[i] = this.week[45 + this.offset + i]
          chartTemp.labels[i] = moment(objDate).format('MM/DD')
        }
      } else {
        objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 * 28 + this.offset * 28)
        this.rankStart = moment(objDate).format('YYYY/MM/DD')
        objDate = new Date()
        objDate.setDate(objDate.getDate() + this.offset * 28)
        this.rankEnd = moment(objDate).format('YYYY/MM/DD')

        for (i = 0; i < counter; i++) {
          objDate = new Date()
          objDate.setDate(
            objDate.getDate() - 6 * 28 + this.offset * 28 + i * 28
          )
          str = moment(objDate).format('YYYY/MM/DD')
          chartTemp.datasets[0].data[i] = this.month[6 + this.offset + i]
          chartTemp.labels[i] = moment(objDate).format('MM/DD')
        }
      }
      this.chartData = chartTemp
    },
    calcRankingSub () {
      var vm = this
      var ranking = {}
      this.groups.forEach(function (group) {
        if (vm.myService.length !== 0) {
          if (group.services[vm.myServiceSelected]) {
            ranking[group.key] = {
              ratio: 0,
              done: 0,
              total: 0,
              name: group.name,
              icon: group.icon,
              key: group.key,
              rank: 0
            }
            for (var key in group.users) {
              if (group.users[key]) {
                var data = vm.usersData[key]
                if (data) {
                  ranking[group.key].done += data.done
                  ranking[group.key].total += data.total
                  if (ranking[group.key].total !== 0) {
                    ranking[group.key].ratio = Math.floor(100 * (ranking[group.key].done / ranking[group.key].total))
                  }
                }
              }
            }
            var i = 0
            var newRanking = new Array(ranking.length)
            for (var temp in ranking) {
              newRanking[i] = [ranking[temp].ratio, temp]
              i++
            }
            vm.ranking = []
            var r = 1
            newRanking.sort(function (a, b) {
              if (a[0] < b[0]) {
                return 1
              }
              return -1
            })
            for (i = 0; i < newRanking.length; i++) {
              key = newRanking[i][1]
              ranking[key].rank = r
              vm.ranking.push(ranking[key])
              r++
            }
          }
        }
      })
    },
    calcRanking () {
      if (this.isCalcRanking) {
        return
      }
      this.isCalcRanking = true
      if (!this.user) {
        return
      }
      var vm = this
      var async = require('async')
      return new Promise((resolve, reject) => {
        this.usersData = {}
        this.getMembers().then(() => {
          var objDate = new Date()
          objDate.setDate(objDate.getDate() - 6 + this.offset)
          var str = moment(objDate).format('YYYY/MM/DD')
          var state = { date: str }
          var day6 = parseInt(moment(Date.parse(state.date)).format('X'))
          async.each(this.users, function (user, cb) {
            if (user.services[vm.myServiceSelected]) {
              vm.usersData[user.key] = {
                ratio: 0,
                done: 0,
                total: 7
              }
              const db = firebase.firestore()
              const settings = { timestampsInSnapshots: true }
              db.settings(settings)
              var dbRef = db.collection('routine_data').doc(user.key).collection('data')
              dbRef.where('date', '>=', day6).get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  var key = doc.ref.parent.parent.id
                  vm.usersData[key].done += 1
                  vm.usersData[key].total = 7
                  if (vm.usersData[key].total !== 0) {
                    vm.usersData[key].ratio = Math.floor(100 * (vm.usersData[key].done / vm.usersData[key].total))
                  }
                  var z = vm.myUsers.findIndex(u => u.key === key)
                  if (z !== -1) {
                    vm.myUsers[z].submitNumber = vm.usersData[key].done
                  }
                })
                vm.calcRankingSub()
                cb()
              })
            } else {
              cb()
            }
          }, function (err) {
            if (err) console.log(err)
            vm.isCalcRanking = false
            resolve()
          })
        })
      })
    },
    getMembers () {
      if (this.isGetMembers) {
        return
      }
      return new Promise((resolve, reject) => {
        this.isGetMembers = true
        var vm = this
        this.members = []
        this.membersData = {}
        this.membersRoutine = {}
        this.membersRoutineNumber = {}

        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        if (this.user && this.user.role === 'user') {
          for (var key in this.user.groups) {
            if (this.user.groups[key]) {
              var index = this.groups.findIndex(g => g.key === key)
              if (index !== -1) {
                var group = JSON.parse(JSON.stringify(this.groups[index]))
                var payload = {
                  group: group,
                  users: []
                }
                for (key in group.users) {
                  if (key !== this.user.key && group.users[key]) {
                    index = this.users.findIndex(u => u.key === key)
                    if (index !== -1) {
                      var user = JSON.parse(JSON.stringify(this.users[index]))
                      user['ratio'] = 0
                      user['total'] = 0
                      user['done'] = 0
                      payload.users.push(user)
                      vm.membersData[user.key] = { ratio: 0, done: 0, total: 0 }
                      vm.membersRoutine[user.key] = []
                    }
                  }
                }
                this.members.push(payload)
              }
            }
          }
        } else {
          for (var i = 0; i < this.groups.length; i++) {
            group = JSON.parse(JSON.stringify(this.groups[i]))
            if (this.myService.length !== 0) {
              if (group.services[this.myServiceSelected]) {
                payload = {
                  group: group,
                  users: []
                }
                for (key in group.users) {
                  if (group.users[key]) {
                    index = this.users.findIndex(u => u.key === key)
                    if (index !== -1) {
                      user = JSON.parse(JSON.stringify(this.users[index]))
                      user['ratio'] = 0
                      user['total'] = 0
                      user['done'] = 0
                      payload.users.push(user)
                      vm.membersData[user.key] = { ratio: 0, done: 0, total: 0 }
                      vm.membersRoutine[user.key] = []
                    }
                  }
                }
                this.members.push(payload)
              }
            }
          }
        }
        this.getMembersRoutineData().then(() => {
          this.getMembersRoutineSelf().then(() => {
            this.getUsersForSelectedService()
            vm.isGetMembers = false
            resolve()
          })
        })
      })
    },
    getMembersRoutineData () {
      var vm = this
      var async = require('async')
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - 6 + this.offset)
        var str = moment(objDate).format('YYYY/MM/DD')
        var state = { date: str }
        var day6 = parseInt(moment(Date.parse(state.date)).format('X'))
        async.each(this.members, function (member, cb) {
          async.each(member.users, function (user, cb2) {
            var dbRef = db.collection('routine_data').doc(user.key).collection('data')
            dbRef.where('date', '>=', day6).get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                vm.membersData[doc.ref.parent.parent.id].done += doc.data().routineCounter.total.done + doc.data().routineCounter.total.none
                vm.membersData[doc.ref.parent.parent.id].total +=
                      doc.data().routineCounter.total.none +
                      doc.data().routineCounter.total.undone +
                      doc.data().routineCounter.total.done
                if (vm.membersData[doc.ref.parent.parent.id].total !== 0) {
                  vm.membersData[doc.ref.parent.parent.id].ratio = Math.floor(100 * (vm.membersData[doc.ref.parent.parent.id].done / vm.membersData[doc.ref.parent.parent.id].total))
                }
                for (var i = 0; i < vm.members.length; i++) {
                  for (var x = 0; x < vm.members[i].users.length; x++) {
                    vm.members[i].users[x].total = vm.membersData[vm.members[i].users[x].key].total
                    vm.members[i].users[x].done = vm.membersData[vm.members[i].users[x].key].done
                    vm.members[i].users[x].ratio = vm.membersData[vm.members[i].users[x].key].ratio
                  }
                }
              })
              cb2()
            })
          }, function (err) {
            if (err) console.log(err)
            cb()
          })
        }, function (err) {
          if (err) console.log(err)
          resolve()
        })
      })
    },
    getMembersRoutineSelf () {
      var vm = this
      var async = require('async')
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        async.each(this.members, function (member, cb) {
          async.each(member.users, function (user, cb2) {
            var dbRef = db.collection('routine_self').doc(user.key).collection('data')
            dbRef.get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if (vm.user.role !== 'user') {
                  var routine = JSON.parse(JSON.stringify(doc.data()))
                  routine['key'] = doc.id
                  var index = vm.membersRoutine[doc.ref.parent.parent.id].findIndex(routine => routine.key === doc.id)
                  if (index === -1) {
                    routine.category = '[' + vm.categoryText(routine.category) + ']'
                    vm.membersRoutine[doc.ref.parent.parent.id].push(routine)
                  }
                } else if (doc.data().share === true && doc.data().done === false) {
                  routine = JSON.parse(JSON.stringify(doc.data()))
                  routine['key'] = doc.id
                  index = vm.membersRoutine[doc.ref.parent.parent.id].findIndex(routine => routine.key === doc.id)
                  if (index === -1) {
                    routine.category = '[' + vm.categoryText(routine.category) + ']'
                    vm.membersRoutine[doc.ref.parent.parent.id].push(routine)
                  }
                }
              })
              vm.getRountineNumber(user)
              cb2()
            })
          }, function (err) {
            if (err) console.log(err)
            cb()
          })
        }, function (err) {
          if (err) console.log(err)
          resolve()
        })
      })
    },
    getRountineNumber (user) {
      var number = 0
      for (var key in user.services) {
        if (user.services[key] && this.myServiceSelected === key) {
          var index = this.services.findIndex(service => service.key === key)
          for (var offset in this.services[index].routine) {
            var x = this.routineRefs.findIndex(ref => ref.key === this.services[index].routine[offset])
            if (x !== -1) {
              var y = this.routineGroups.findIndex(refg => refg.key === this.routineRefs[x].routine_ref)
            }
            if (y !== -1) {
              number += this.routineGroups[y].routines.length
            }
          }
        }
      }
      for (key in user.groups) {
        if (user.groups[key]) {
          index = this.groups.findIndex(group => group.key === key)
          if (index !== -1) {
            for (offset in this.groups[index].routine) {
              x = this.routineRefs.findIndex(ref => ref.key === this.groups[index].routine[offset])
              if (x !== -1) {
                y = this.routineGroups.findIndex(refg => refg.key === this.routineRefs[x].routine_ref)
              }
              if (y !== -1) {
                number += this.routineGroups[y].routines.length
              }
            }
          }
        }
      }
      for (offset in user.routine) {
        x = this.routineRefs.findIndex(ref => ref.key === user.routine[offset])
        if (x !== -1) {
          y = this.routineGroups.findIndex(refg => refg.key === this.routineRefs[x].routine_ref)
        }
        if (y !== -1) {
          number += this.routineGroups[y].routines.length
        }
      }
      if (this.membersRoutine[user.key]) {
        number += this.membersRoutine[user.key].length
      }
      this.membersRoutineNumber[user.key] = number
      return number
    },
    getUsersForSelectedService () {
      this.myUsers = []
      for (var index in this.users) {
        var user = JSON.parse(JSON.stringify(this.users[index]))
        if (user.services[this.myServiceSelected] != null && user.services[this.myServiceSelected]) {
          user['routineNumber'] = this.getRountineNumber(user)
          user['submitNumber'] = 0
          this.myUsers.push(user)
        }
      }
      // for (var index in this.members) {
      //   var group = this.members[index]
      //   for (index in group.users) {
      //     var check = this.myUsers.findIndex(user => user.key === group.users[index].key)
      //     if (check === -1) {
      //       var user = group.users[index]
      //       user['routineNumber'] = this.getRountineNumber(user)
      //       user['submitNumber'] = 0
      //       this.myUsers.push(user)
      //     }
      //   }
      // }
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      routineSelf: 'routineSelf/routineSelf',
      routineData: 'routineData/routineData',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      data: 'dispatch/data',
      register: 'register/register',
      init: 'authUser/init'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.select-btn {
  width: 60px
}
table td {
  vertical-align: middle !important;
}
th {
  white-space: nowrap;
}
.th-date {
  white-space: pre-line;
  text-align: center;
}

.status {
  max-width:180px;
}
/* @media screen {
  #printSection {
      display: none;
  }
}
@media print {
  body * {
    visibility:hidden;
  }
  #printSection, #printSection * {
    visibility:visible;
  }
  #printSection {
    position:absolute;
    left:0;
    right: 0;
    top:0;
  }
  #print-button {
    display: none;
  }
} */

.my-gray {color: gray}
.my-blue {color: blue}
.my-orange {color: #fecb81}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue